import { getAppEndpointVersion } from 'helpers'
import { getChatApiBase, getChatApiHeaders } from './chatApiClient'
import axios from './axiosInstance'

export default function init() {
}

// Helper function to append message filters to URL (DRY)
function appendMessageFilters(url, filters) {
  let result = url
  
  // Handle single sender
  if (filters.sender) {
    result += `&sender=${encodeURIComponent(filters.sender)}`
  }
  
  // Handle multiple senders
  if (filters.senders) {
    result += `&senders=${encodeURIComponent(filters.senders)}`
  }
  
  // Handle hasReactions filter
  if (filters.hasReactions !== undefined) {
    result += `&hasReactions=${encodeURIComponent(filters.hasReactions)}`
  }
  
  // Handle sentAt[from] filter
  if (filters.sentAtFrom) {
    result += `&sentAt[from]=${encodeURIComponent(filters.sentAtFrom)}`
  }
  
  // Handle sentAt[to] filter
  if (filters.sentAtTo) {
    result += `&sentAt[to]=${encodeURIComponent(filters.sentAtTo)}`
  }
  
  // Handle single type
  if (filters.type) {
    result += `&type=${encodeURIComponent(filters.type)}`
  }
  
  // Handle multiple types
  if (filters.types) {
    result += `&types=${encodeURIComponent(filters.types)}`
  }
  
  // Legacy support for old filter names (only if primary filter not set)
  if (filters.message_type && !filters.type) {
    result += `&type=${encodeURIComponent(filters.message_type)}`
  }
  if (filters.sender_uids && !filters.senders) {
    result += `&senders=${encodeURIComponent(filters.sender_uids)}`
  }
  
  // Handle date range filters
  if (filters.dateRangeFrom && filters.dateRangeTo) {
    result += `&dateRange[field]=sentAt&dateRange[from]=${encodeURIComponent(filters.dateRangeFrom)}&dateRange[to]=${encodeURIComponent(filters.dateRangeTo)}`
  } else if (filters.dateRangeFrom) {
    result += `&dateRange[field]=sentAt&dateRange[from]=${encodeURIComponent(filters.dateRangeFrom)}`
  } else if (filters.dateRangeTo) {
    result += `&dateRange[field]=sentAt&dateRange[to]=${encodeURIComponent(filters.dateRangeTo)}`
  }
  
  return result
}

export async function getAppMessages(app, apiHost, type = 'current', id = 0, filters = {}) {
  let URL
  const categories = filters.categories || 'custom,message,interactive,agentic'
  if (type === 'previous') {
    URL = `${getChatApiBase(app, apiHost)}/messages?hideDeleted=1&limit=30&affix=prepend&id=${id}&categories=${categories}`
  } else if (type === 'next') {
    if (id > 0)
      URL = `${getChatApiBase(app, apiHost)}/messages?hideDeleted=1&limit=30&affix=append&id=${id}&categories=${categories}`
    else
      URL = `${getChatApiBase(app, apiHost)}/messages?hideDeleted=1&limit=30&categories=${categories}`
  } else {
    URL = `${getChatApiBase(app, apiHost)}/messages?hideDeleted=1&limit=30&categories=${categories}`
  }

  URL = appendMessageFilters(URL, filters)

  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function searchAppMessages(app, apiHost, fromDate, toDate, type = 'current', id = 0, filters = {}) {
  let URL = `${getChatApiBase(app, apiHost)}/messages?fromTimestamp=${fromDate}&toTimestamp=${toDate}&hideDeleted=1&limit=500&categories=${filters.categories || 'custom,message,interactive,agentic'}`
  if (type === 'previous') {
    URL = `${URL}&affix=prepend&id=${id}`
  }

  URL = appendMessageFilters(URL, filters)

  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function exportAppMessages(app, apiHost, type = 'current', sentAt = 0, id = 0) {
  let URL

  if (type === 'previous') {
    URL = `${getChatApiBase(app, apiHost)}/messages?sentAt=${sentAt}&hideDeleted=1&limit=1000&affix=prepend&id=${id}&categories=custom,message,interactive,agentic`
  } else {
    URL = `${getChatApiBase(app, apiHost)}/messages?hideDeleted=1&limit=1000&categories=custom,message,interactive,agentic`
  }
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getModerationMessages(app, apiHost, id = 0) {
  let URL
  if (id > 0)
    URL = `${getChatApiBase(app, apiHost)}/users/app_system/messages?hideDeleted=1&per_page=50&category=custom&type=extension_human-moderation&affix=append&id=${id}`
  else
    URL = `${getChatApiBase(app, apiHost)}/users/app_system/messages?hideDeleted=1&per_page=50&category=custom&type=extension_human-moderation&affix=append&id=0.5`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function deleteAppMessageLog(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/messages/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function rejectModMessageLogs(message, app) {
  // PTM ADD THE URL
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}human-moderation-${app.region}.cometchat.io/v1/reject`
  // change the headers
  return axios
    .post(`${URL}`, message, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatAPIVersion: getAppEndpointVersion(app),
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function approveModMessageLogs(message, app) {
  // PTM ADD THE URL
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}human-moderation-${app.region}.cometchat.io/v1/approve`
  return axios
    .post(`${URL}`, message, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatAPIVersion: getAppEndpointVersion(app),
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function add(payload, id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}/messages`
  return axios
    .post(`${URL}`, payload, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getGroupMessages(app, guid = 0, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/groups/${guid}/messages?hideDeleted=1&limit=100`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function deleteGroupMessageLog(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/messages/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getAppMessageByID(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/messages/${id}`

  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getUserMessages(app, apiHost, userUid, onBehalfOfUid, params = {}) {
  const query = Object.keys(params)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&')
  const URL = `${getChatApiBase(app, apiHost)}/users/${encodeURIComponent(
    userUid,
  )}/messages${query ? `?${query}` : ''}`
  const headers = { ...getChatApiHeaders(app) }
  if (onBehalfOfUid) headers.onBehalfOf = onBehalfOfUid

  return axios
    .get(`${URL}`, {
      headers,
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response?.data || { error: 'Failed to fetch user messages' }
    })
}

export async function getMessages(app, apiHost, params = {}, onBehalfOfUid) {
  // params: object with query params like perPage, limit, fromTimestamp, toTimestamp, etc.
  const withTs = { ...params, ts: Date.now() }
  const query = Object.keys(withTs)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(withTs[k])}`)
    .join('&')
  const URL = `${getChatApiBase(app, apiHost)}/messages${query ? `?${query}` : ''}`
  const headers = { ...getChatApiHeaders(app) }
  if (onBehalfOfUid) headers.onBehalfOf = onBehalfOfUid

  return axios
    .get(`${URL}`, {
      headers,
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response?.data || { error: 'Failed to fetch messages' }
    })
}

export async function getMessageCategories(app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/messageCategories`

  try {
    const response = await axios.get(URL, {
      headers: getChatApiHeaders(app),
    })
    return response.data
  } catch (error) {
    return error?.response?.data || { error: 'Failed to fetch message categories' }
  }
}
